import { useAuth } from '../auth/AuthContext';

/**
 * Hook form: const canEdit = useCan('admins.update');
 */
export function useCan(permission) {
  const { can } = useAuth();
  return can(permission);
}

/**
 * Component form:
 *   <Can permission="admins.create"><button>New</button></Can>
 *   <Can permission="admins.create" fallback={<Locked />}>...</Can>
 */
export default function Can({ permission, children, fallback = null }) {
  const { can } = useAuth();
  return can(permission) ? children : fallback;
}
